import React, {useEffect, useRef, useState} from "react";
import {useParams} from "react-router-dom";
import {
    FlyerLanguageDto,
    FlyerPageDto,
    LanguageCulture,
    flipbookEditorUrlDto,
    UserDto,
    FlyerStatus,
    FlyerDto, IconStyleDto
} from "../../dtos";
import {
    getFlippingFlyer,
} from "../../store";
import {useDispatch} from "react-redux";
import {useTypedSelector} from "../../hooks/useTypeSelector";
import {
    Box,
    Button,
    Divider,
    FormControlLabel,
    Grid,
    Radio,
    RadioGroup,
    Typography,
    useMediaQuery
} from "@mui/material";
import {PageSpinner} from "../com/pagesTab/pagesSpinner/spinner";
import {ReactComponent as LeftIcon} from "../../assets/editors/flyers_left_arrow.svg";
import {ReactComponent as UploadCloudIcon} from "../../assets/upload_excel_cloud_icon.svg";
import {ReactComponent as UploadPDFIcon} from "../../assets/editors/upload_pdf_icon.svg";
import {makeStyles} from "@mui/styles";
import envManager from "../../com/envManager/EnvManager";
import {SelectWithLabel} from "../../com/selectWithLabel/selectWithLabel";
import {TextInputWithLabel} from "../../com/textInputWithLabel/textInputWithLabel";

import moment from "moment/moment";
import {DatePickerComponent} from "../../com/datePickerComponent/datePickerComponent";
import ColorsSelector from "../../com/colorsSelector2/ColorsSelector";
import {AsyncImageWithLoader} from "../../com/imageWithLoader/imageWithLoader";
import ImageLoader from "../../com/imageLoader/ImageLoader";
import {createFlyerFromPdfFile, updateFlipbook} from "../../store/actionCreators/flyerFromPdfActionCreator";
import {startUploadingImagesProgressPopup} from "../../store/actionCreators/uploadingImagesProgressActionCreator";
import StatusPopup, {StatusPopupType} from "../../com/statusPopup/StatusPopup";
import {getSettingsForPopup} from "../editor/pages/getSetttingsForPopup";
import {FLYER_STATUSES} from "../../globals";
import {FlippingFlyerTocTab} from "./flippingFlyerTocTab";
import validator from "validator";
import {history} from '../../helpers/history';
import ExpandCollapseBtn from "../../com/expandCollapseBtn/expandCollapseBtn";
import {getDate, getIconStyle} from "../../globals/globFunctions";
import FontsSelect from "../../com/fontsSelect/fontsSelect";

const useStyles = makeStyles(() => ({
    backIconWrapper: {
        display: `flex`,
        justifyContent: `flex-start`,
        position: `absolute`,
        top: `12px`,
        left: `12px`,
        zIndex: 1
    },
    backToFlyersBtn: {
        '&.MuiButtonBase-root': {
            display: `flex`,
            alignItems: `center`,
            justifyContent: `center`,
            height: `40px`,
            width: `40px`,
            backgroundColor: `#014780`,
            '&:hover': {
                backgroundColor: `#014780`,
            },
            '& > svg': {
                width: `12px`,
                height: `12px`,
                '&  > path': {
                    fill: `#FFFFFF`
                }
            }
        }
    },
    flyerContentWrapper: (props: any) => ({
        display: `flex`,
        flexFlow: `column`,
        height: `100%`,
        width: `100%`,
        paddingBottom: "12px",
        // margin: `0 auto`,
        justifyContent: `center`,
        position: `relative`,
        // [theme.breakpoints.down('xs')]: {
        //     width: `100%`
        // }
    }),
    flyerContent: {
        flex: `1 1 auto`,
        height: `0px`, overflow: `auto`,
        display: `flex`,
        flexFlow: `column`,
        // '&::-webkit-scrollbar': {
        //     width: `12px`,
        //     height: `10px`
        // },
        //
        // '&::-webkit-scrollbar-track': {
        //     webkitBoxShadow: `inset 0 0 6px rgba(0,0,0,0.3)`,
        //     borderRadius: `10px`,
        //     backgroundColor: `#e4e4e433`
        // },
        //
        // '&::-webkit-scrollbar-thumb': {
        //     borderRadius: `10px`,
        //     boxShadow: `inset 0 0 6px rgba(0,0,0,0.5)`,
        // }
    },
    datePickerWrapper: {
        position: `relative`,
        display: `flex`,
        flexFlow: `row`,
        width: `100%`,
        border: `1px solid black`,
        cursor: "pointer"
    },
    captionWrapper: {},
    urlWrapper: {},
    languageWrapper: {},
    durationWrapper: {},
    uploadPdfPagesWrapper: {
        minHeight: `168px`,
        maxHeight: `168px`,
        display: `flex`,
        flexFlow: `row`,
        alignItems: `center`,
        marginBottom: "16px",
        padding: "16px",
        columnGap: `2%`
    },
    previewFlyerFirstPageBox: {
        width: `40%`,
        height: `100%`,
        maxHeight: `100%`,
        maxWidth: `100%`
    },

    uploadButton: {
        '&.MuiButtonBase-root': {
            padding: `10px 0`,
            height: `100%`,
            flex: `1 1 auto`,
            // width: `100%`,
            // height: `64px`,
            display: `flex`,
            alignItems: `center`,
            justifyContent: `center`,
            border: `2px dashed #888888`,
            borderRadius: `0`,
            boxShadow: `none`,
            backgroundColor: `#ffffff`,
            '&:hover': {
                backgroundColor: `#ffffff`,
                boxShadow: `none`
            }
        }
    },
    uploadLogoWrapper: {
        display: `flex`,
        flexFlow: `row`,
        width: `100%`,
        height: `64px`,
        margin: `20px 0 15px`,
        padding: 0,
        columnGap: `2%`
    },
    uploadLogoButton: {
        '&.MuiButtonBase-root': {
            // width: `50%`,
            flex: `1 1 auto`,
            height: `100%`,
            display: `flex`,
            alignItems: `center`,
            justifyContent: `center`,
            border: `2px dashed #888888`,
            borderRadius: `0`,
            boxShadow: `none`,
            backgroundColor: `#ffffff`,
            '&:hover': {
                backgroundColor: `#ffffff`,
                boxShadow: `none`
            }
        }
    },
    uploadedLogoView: {
        width: `40%`,
        maxWidth: `100%`,
        maxHeight: `100%`,
        display: `flex`,
        alignItems: `center`,
        justifyContent: `center`,
    },
    dropdownBtn: {
        '&.MuiButton-root': {
            display: `flex`,
            justifyContent: `space-between`,
            width: `100%`,
            borderRadius: `5px`,
            boxShadow: `none`,
            height: `36px`,
            backgroundColor: `#88888880`,
            '&:hover': {
                backgroundColor: `#88888880`,
                boxShadow: `none`
            },
            '& > .MuiTypography-root': {
                textAlign: `start`,
                padding: `0 5px`,
                color: `#000000`,
                fontWeight: `500`
            },
            '& > .MuiTouchRipple-root': {
                color: `white`
            }
        }
    },
    dropdownIcon: {
        width: `40px`,
        height: `100%`,
        display: `flex`,
        alignItems: `center`,
        justifyContent: `center`,
        '& > svg': {
            transition: `transform 0.5s ease-in`,
        },
        '&.active > svg': {
            transform: `rotate(90deg)`,
        }
    },
    dropdownContentWrapper: {
        width: `100%`,
        backgroundColor: `red`,
        display: `flex`,
        overflow: `hidden`,
        height: `0px`,
        transition: `height 0.5s ease-in`,
        // display: `none`,
    },
    dropdownContent: {},
    dropdownSelector: {
        height: `48px`,
        '& .font_selector__single-value': {
            opacity: 1
        }
    },
    controlButton: {
        '&.MuiButton-root': {
            width: `100%`,
            color: `initial`,
            background: `#014780`,
            // background: `linear-gradient(135.47deg, #DD5A01 3.9%, #F0CA21 100%)`,
            height: `48px`,
            margin: `15px 10px 0`,
            borderRadius: `0`,
            '&:hover': {
                background: `#014780`,
                opacity: `0.7`
            },
            '&:disabled': {
                opacity: `0.5`
            }

        }

    },
    tabs: {
        display: "flex",
        width: `100%`,
        minHeight: `50px`,
        // flexShrink: `0`,
        '& > .MuiButton-root': {
            width: `100%`,
            borderRadius: `0`,
            backgroundColor: `#D0E0F0`,
            color: `initial`,
            '&:hover': {
                backgroundColor: `#D0E0F0`,
            }
        }
    },
    activeTab: (props: any) => ({
        '&.MuiButton-root': {
            width: `100%`,
            borderRadius: `0`,
            backgroundColor: `#ffffff`,
            color: `initial`,
            borderTop: props.isXs ? `2px solid #2A38BB`: "none",
            '& > .MuiTypography-root': {
                color: `#2A38BB`,
                fontWeight: `700`
            },
            '&:hover': {
                backgroundColor: `#ffffff`,
            }
        }
    }),
    tabsPanel: {
        overflow: "auto",
        padding: `0 16px`
    },
    radioBtnGroup: {
        justifyContent: `space-between`,
        "& > .MuiFormControlLabel-root": {
            // marginLeft: `-6px`,
            // marginRight: `0`,
            // marginBottom: `0`,
            margin: `8px 0 0 0px`,
            "& > .MuiRadio-root": {
                padding: `3px`,
            },
        },
    },
}))

export interface DefaultFlyerStateForSelfService {
    caption?: string;
    displayCaption?: string;
    language?: { value: string | undefined; label: string, id: number };
    startDate?: any;
    endDate?: any;
    pdfFile?: File | null;
    guiColor?: string;
    fontFamily?: string;
    logo?: string | null;
    logoFile?: File | null;
    bgColor?: string;
    pages?: FlyerPageDto[];
    bgImage?: string;
    bgImageFile?: File | null;
    flyerId?: number,
    flyerStatusCode?: string;
    homePage?: string;
    iconStyle?: IconStyleDto;
}

interface Props {
    isSm?: boolean;
    activeFlyers?: FlyerDto[];
    rightPanelAnimationTimeInMs?: number

}

export const FlippingFlyersCatalogCreateEditFlyer: React.FC<Props> = ({
                                                                          isSm = true,
                                                                          activeFlyers = [],
                                                                          rightPanelAnimationTimeInMs= 0
                                                                      }) => {
    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    let flippingFlyerState = useTypedSelector((state) => state.flippingFlyer);
    let flyersState = useTypedSelector((state) => state.flyers);
    let flyerDataFromPdf = useTypedSelector((state) => state.flyerDataFromPdf);
    let uploadImagesPopup = useTypedSelector((state) => state.uploadImagesPopup);
    const {isShowRightPanel} = useTypedSelector((state) => state.toggleActionsForFlyers);
    const dispatch = useDispatch();
    const {flyerId} = useParams<flipbookEditorUrlDto>();
    const [isLoading, setLoading] = useState<boolean>(false);
    const startDateRef = useRef(null);
    const endDateRef = useRef(null);
    const isXs = useMediaQuery(`(max-width:599px)`);
    const stylesProperties = {
        isXs: isXs,
        isSm: isSm
    }
    // console.table(FLYER_STATUSES);
    const classes = useStyles(stylesProperties);
    const [flyerState, setFlyerState] = useState<DefaultFlyerStateForSelfService>({});
    const [defaultFlyerState, setDefaultFlyerState] = useState<DefaultFlyerStateForSelfService>({});
    // const [isOpenToCSection, setOpenToCSection] = useState<boolean>(false);
    // const [isOpenBrandingSection, setOpenBrandingSection] = useState<boolean>(false);
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);
    const [tabPanelIndex, setTabPanelIndex] = useState<number>(0);
    const [isImageUrlSelected, setImageUrlMain] = useState<boolean>(false);
    const [isModalPopup, changeModalStatus] = useState(false);
    const [modalName, setModalName] = useState('');
    const languages = flyersState?.languageCultures?.map((lang: FlyerLanguageDto) => {
        return {
            value: lang.code,
            label: lang.caption,
            id: lang.id,
            language: {
                ...lang
            }
        }
    });
    const onlyHebrewPattern = new RegExp(/^[a-zA-Z0-9\u0590-\u05fe-_]+$/i);

    useEffect(() => {
        if (flyerState.pdfFile) {
            changeModalStatus(true);
            setModalName('uploadPdfFileToFlipbook');
        }
    }, [flyerState.pdfFile]);

    useEffect(() => {
        const stateIsNotChanged = compareDefaultItemStateWithCurrentItemState();
        // dispatch(someFlyerDetailsDataWasChangedInFlyerDetailsPopup(!stateIsNotChanged));
    }, [flyerState])

    useEffect(() => {
        if (!flyerState.pdfFile && flyerDataFromPdf.flyerId) {
            setLoading(true);
            if (flyerDataFromPdf.type === 'UPDATE_FLIPBOOK_SUCCESS' && isSm) {
                setLoading(false);
                dispatch(getFlippingFlyer(Number(flyerDetailsState.flyRecId)));
            }
        }
    }, [flyerDataFromPdf, flyerState.pdfFile]);

    // useEffect(() => {
    //     if(flyerId){
    //         dispatch(getFlippingFlyer(Number(flyerId)));
    //     } else {
    //         setLoading(false);
    //     }
    //     return () => {
    //         setLoading(true);
    //         dispatch(resetFlyerState());
    //     }
    // }, [flyerId]);

    useEffect(() => {
        if (uploadImagesPopup.processingFinished && flyerDataFromPdf.flyerId && uploadImagesPopup.isOpen) {
            if (flyerDataFromPdf.flyerId === flyerDetailsState.flyRecId) {
                dispatch(getFlippingFlyer(Number(flyerDetailsState.flyRecId)));
            } else {
                // history.push(`/flipbookEditor/${flyerDataFromPdf.flyerId}`)
            }
        }
    }, [uploadImagesPopup.processingFinished])

    useEffect(() => {
        setLoading(flippingFlyerState.loading);
        // if (flippingFlyerState.type?.indexOf('_COMPLETED') === -1) {
        //     if (flippingFlyerState.type === 'GET_FLIPPING_FLYER_ERROR') {
        //         //go to flyers screen
        //         goToFlyersScreen();
        //     }
        // }
    }, [flippingFlyerState.type]);

    useEffect(() => {
        console.log(flyerDetailsState);
        const newState: DefaultFlyerStateForSelfService = {
            caption: flyerDetailsState.flyCaption,
            displayCaption: flyerDetailsState.flyDisplayCaption,
            language: getLanguage(flyerDetailsState.flyLacRec),
            startDate: flyerDetailsState.flyValidFromUtc ? getDate(flyerDetailsState.flyValidFromUtc) : getDate(moment(new Date()).toDate()),
            endDate: flyerDetailsState.flyValidToUtc ? getDate(flyerDetailsState.flyValidToUtc) : getDate(moment(new Date()).endOf('year').add(1, 'days').toDate()),
            pdfFile: null,
            guiColor: flyerDetailsState.flyGusRec?.gusPrimaryColorRgb ? flyerDetailsState.flyGusRec.gusPrimaryColorRgb : `#1A1483`,
            fontFamily: flyerDetailsState.flyGusRec?.gusFont ? flyerDetailsState.flyGusRec.gusFont : `Roboto`,
            logo: flyerDetailsState.flyGusRec?.gusLogoUrl ? flyerDetailsState.flyGusRec.gusLogoUrl : null,
            bgColor: flyerDetailsState.flyGusRec?.gusBackgroundColorRgb ? flyerDetailsState.flyGusRec.gusBackgroundColorRgb : `#ffffff`,
            pages: flyerDetailsState.flyerPages ? flyerDetailsState.flyerPages : [],
            bgImage: flyerDetailsState.flyGusRec?.gusBackgroundImageUrl ? flyerDetailsState.flyGusRec?.gusBackgroundImageUrl : ``,
            flyerId: flyerDetailsState.flyRecId,
            flyerStatusCode: flyerDetailsState.flyFstRec.fstCode ? flyerDetailsState.flyFstRec.fstCode.toString() : `1`,
            homePage: flyerDetailsState?.urls?.accountHomePageUrl || "www.xcircular.com",
            iconStyle: getIconStyle(flyerDetailsState.flyGusRec?.gusIconContrast || 1)
        }
        setImageUrlMain(!Boolean(flyerDetailsState.flyGusRec?.gusBackgroundColorRgb) && Boolean(flyerDetailsState.flyGusRec?.gusBackgroundImageUrl));
        setFlyerState(newState);
        setDefaultFlyerState(newState);
    }, [
        flyerDetailsState.flyCaption,
        flyerDetailsState.flyDisplayCaption,
        flyerDetailsState.flyLacRec,
        flyerDetailsState.flyValidFromUtc,
        flyerDetailsState.flyValidToUtc,
        flyerDetailsState.flyGusRec,
        flyerDetailsState.flyerPages,
        flyerDetailsState.flyRecId,
        flyerDetailsState.flyFstRec,
        flyerDetailsState.urls,
    ])

    const getLanguage = (
        lang: LanguageCulture | undefined
    ): { value: string | undefined; label: string; id: number } => {
        return lang !== null ?
            {
                value: lang!.lacCode!,
                label: lang!.lacCaption!,
                id: lang!.lacRecId!
            } : {
                value: "en-US",
                label: `English (US)`,
                id: 1
            };
    };

    const goToFlyersScreen = () => {
        history.push(`/flyersCatalog`)
    }

    const onChangeDisplayCaption = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const value = e.target.value;
        value.trimStart().replace(/\s\s+/g, ' ');
        setFlyerState({
            ...flyerState,
            displayCaption: value.trimStart().replace(/\s\s+/g, ' '),
            caption: value.trim().replace(/\s\s+/g, ' ').replace(/ /g, '-')
        })
    }

    const onChangeHomePageUrl = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const value = e.target.value;
        setFlyerState({
            ...flyerState,
            homePage: value,
        })
    }

    const onChangeDatePicker = (value: Date, name: string) => {
        setFlyerState({
            ...flyerState,
            [name]: value,
        });
    }

    const onFileSelected = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files![0];
        if (file && flyerDetailsState.flyRecId === 0) {
            // history.push(`/flipbookEditor/352`)
            dispatch(startUploadingImagesProgressPopup());
            dispatch(createFlyerFromPdfFile(file));
        } else {
            setFlyerState({
                ...flyerState,
                pdfFile: file
            })
            //
            // setFlyerState({
            //     ...flyerState,
            //     pdfFile: file ? file : null
            // });
        }
    }

    const onGuiColorChange = (hexColor: string) => {
        setFlyerState({
            ...flyerState,
            guiColor: hexColor
        })
    }

    const onBgColorChange = (hexColor: string) => {
        setFlyerState({
            ...flyerState,
            bgColor: hexColor,
            bgImageFile: null,
            bgImage: ''
        });
        setImageUrlMain(false);
    }

    const onFontSelectorChange = (value: string) => {
        setFlyerState({
            ...flyerState,
            fontFamily: value
        });
    }

    const onUploadLogoFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files![0];

        let imageLoader = new ImageLoader();
        let imageDimensions = await imageLoader.loadImageDimensions(file);
        if (imageDimensions.width > 300 || imageDimensions.height > 200) {
            alert('Logo must be smaller than 300x200px.')
            return;
        }

        setFlyerState({
            ...flyerState,
            logoFile: file,
            logo: URL.createObjectURL(file)
        });


        //props.state.uploadLogo = newLogo;

        // props.stateChange();
    }

    const changeFlyerStatus = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFlyerState({
            ...flyerState,
            [event.target.name]: event.target.value,
        });
    }

    const setIconStyle = (iconStyle: IconStyleDto) => {
        setFlyerState({
            ...flyerState,
            iconStyle: iconStyle,
        });
    }

    const onUploadBgFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files![0];

        /*
                let imageLoader = new ImageLoader();
                let imageDimensions = await imageLoader.loadImageDimensions(file);
                if (imageDimensions.width > 300 || imageDimensions.height > 200) {
                    alert('Logo must be smaller than 300x200px.')
                    return;
                }
        */
        setFlyerState({
            ...flyerState,
            bgImageFile: file ? file : null,
            bgImage: file ? URL.createObjectURL(file) : ``
        });
        setImageUrlMain(true);

        //props.state.uploadLogo = newLogo;

        // props.stateChange();
    }

    const compareDefaultItemStateWithCurrentItemState = (): boolean => {
        const stringDefaultState = JSON.stringify(flyerState);
        const stringCurrentState = JSON.stringify(defaultFlyerState);
        return stringDefaultState === stringCurrentState;
    }

    const checkAllRequiredFieldsInPopup = (): boolean => {
        return onlyHebrewPattern.test(flyerState.caption!);
        // return flyerState.pdfFile !== null && flyerState.caption !== '' && !onlyHebrewPattern.test(flyerState.caption!);
    }

    const checkAllRequirementsForSavingFlyer = (): boolean => {
        //disable if one of condition is true
        return compareDefaultItemStateWithCurrentItemState() || !checkAllRequiredFieldsInPopup() || !validator.isURL(flyerState?.homePage ? flyerState?.homePage : "");
    }

    const onTabClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        setTabPanelIndex(e.currentTarget.tabIndex);
    }

    const openFlyerInTab = () => {
        window.open(`${envManager.flyerAppAddress}/${flyerDetailsState.flyFltRec?.fltCode === 1 ? "flipbook" : "flyer"}/${userDto.company}/${flyerState.caption?.trim()}`, 'urlFromFlippingEditorScreen');
    }

    const onSaveFlyer = () => {
        dispatch(updateFlipbook(flyerState, flyersState));
    }

    const onCloseConfirmPopup = () => {
        changeModalStatus(false);
        setFlyerState({
            ...flyerState,
            pdfFile: null
        })
    }

    const confirmUploadPdfToFlipbook = () => {
        dispatch(startUploadingImagesProgressPopup());
        dispatch(updateFlipbook(flyerState, flyersState));
        onCloseConfirmPopup();
    }

    const settings = {
        typeStatus: 0,
        title: '',
        subTitle: '',
        messages: [],
        modalName: modalName,
        confirmOnClick: {
            uploadPdfFileToFlipbook: confirmUploadPdfToFlipbook
        }
    };

    let settingsForPopup = getSettingsForPopup(settings);

    return (
        <Box
            sx={{
                // position: "relative",
                height: "100%",
            }}
        >
            {
                !isSm &&
                <ExpandCollapseBtn setLoading={setLoading} animationTime={rightPanelAnimationTimeInMs || 0}/>
            }
            {
                (isShowRightPanel && (isLoading && activeFlyers.length === 1) || (isLoading && flyerId)) &&
                <Box
                    sx={{
                        width: "100%",
                        height: "inherit",
                        backgroundColor: "#ffffff",
                        // zIndex: 3,
                        // position: "absolute"
                    }}
                >
                    <PageSpinner/>
                </Box>
            }

            {
                isShowRightPanel && activeFlyers.length === 0 && !flyerId &&
                <Box
                    sx={{
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"

                    }}
                >
                    <Typography>
                        No flyer selected
                    </Typography>
                </Box>
            }

            {
                isShowRightPanel && !isLoading && activeFlyers.length > 1 && !flyerId &&
                <Box
                    sx={{
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"

                    }}
                >
                    <Typography>
                        Please select only one Flyer
                    </Typography>
                </Box>

            }
            {
                ((!isLoading && isSm) || (activeFlyers.length === 1 && !isLoading && isShowRightPanel)) &&
                <>
                    {
                        isSm &&
                        <Box
                            className={classes.backIconWrapper}
                        >
                            <Button
                                onClick={goToFlyersScreen}
                                className={classes.backToFlyersBtn}
                            >
                                <LeftIcon/>
                            </Button>
                        </Box>
                    }
                    <Box
                        className={classes.flyerContentWrapper}
                    >
                        {
                            isSm &&
                            <Box>
                                <Typography textAlign={`center`} fontSize={`20px`} fontWeight={700} py={`16px`} mx={`52px`} noWrap>
                                    {flyerDetailsState.flyRecId ? `Edit ${flyerDetailsState.flyDisplayCaption}` : `Create New Flipbook`}
                                </Typography>
                            </Box>
                        }
                        <Box className={classes.flyerContent}
                        >
                            <Box className={classes.uploadPdfPagesWrapper} sx={{
                                minHeight: flyerState?.pages && flyerState.pages.length > 0 ? `168px` : `84px`
                            }}>
                                {
                                    flyerState?.pages && flyerState.pages.length > 0 &&
                                    <Box className={classes.previewFlyerFirstPageBox}>
                                        <AsyncImageWithLoader
                                            src={flyerState.pages[0].flyImageThumbnailUrl ? flyerState.pages[0].flyImageThumbnailUrl : ``}/>
                                    </Box>
                                }
                                <Button
                                    disabled={(flyerState.displayCaption === '' || !checkAllRequiredFieldsInPopup()) && flyerState.flyerId !== 0 || !uploadImagesPopup.processingFinished}
                                    variant={`contained`}
                                    component="label"
                                    className={classes.uploadButton}
                                    sx={{
                                        flexFlow: flyerState?.pages && flyerState.pages.length > 0 ? `column` : `row`
                                    }}
                                >
                                    <UploadPDFIcon style={{margin: `5px 0 10px`}}/>
                                    <Typography color={`#000000`} mx={`10px`}>
                                        Upload PDF File
                                    </Typography>
                                    <input
                                        type="file"
                                        accept={`.pdf`}
                                        multiple={false}
                                        onChange={onFileSelected}
                                        hidden
                                    />
                                </Button>
                            </Box>
                            {
                                flyerDetailsState.flyRecId !== 0 &&
                                // flyerState.pages && flyerState.pages.length > 0 &&
                                <Box sx={{
                                    width: `100%`, overflow: "auto", display: "flex", flexFlow: "column",
                                }}>
                                    <Box className={classes.tabs} mb={`30px`}>
                                        <Button onClick={onTabClick} tabIndex={0}
                                                className={tabPanelIndex === 0 ? classes.activeTab : ``}>
                                            <Typography>
                                                Details
                                            </Typography>
                                        </Button>
                                        <Divider orientation="vertical" color={`#D8E1FF`}/>
                                        <Button onClick={onTabClick} tabIndex={1}
                                                className={tabPanelIndex === 1 ? classes.activeTab : ``}>
                                            <Typography>
                                                Branding
                                            </Typography>
                                        </Button>
                                        <Divider orientation="vertical" color={`#D8E1FF`}/>
                                        <Button onClick={onTabClick} tabIndex={2}
                                                className={tabPanelIndex === 2 ? classes.activeTab : ``}>
                                            <Typography>
                                                ToC
                                            </Typography>
                                        </Button>
                                    </Box>
                                    <Box className={classes.tabsPanel}>
                                        {
                                            tabPanelIndex === 0 &&
                                            <Box>
                                                <Box className={classes.captionWrapper} mb={`20px`}>
                                                    <Box mb={`5px`}>
                                                        <Typography fontWeight={700}>
                                                            Publication Name
                                                        </Typography>
                                                    </Box>
                                                    <Grid container alignItems={`flex-start`}>
                                                        <TextInputWithLabel
                                                            isRequired={true}
                                                            isNotValid={flyerState.displayCaption === '' || !checkAllRequiredFieldsInPopup()}
                                                            labelGridSizeNumber={12}
                                                            fontSize={`16px`}
                                                            valueForInput={flyerState.displayCaption}
                                                            onChangeInput={onChangeDisplayCaption}
                                                            isBold={true}
                                                            fieldName={`flyDisplayCaption`}
                                                            maxLength={1000}
                                                        />
                                                    </Grid>
                                                </Box>
                                                <Box className={classes.urlWrapper} mb={`20px`}>
                                                    <Box>
                                                        <Typography mb={`5px`} fontWeight={700}>
                                                            Publication URL
                                                        </Typography>
                                                    </Box>
                                                    <Box>
                                                        <Typography color={`#A2A2A2`} sx={{
                                                            wordBreak: `break-all`
                                                        }}>
                                                            {`${envManager.flyerAppAddress}/${flyerDetailsState.flyFltRec?.fltCode === 1 ? "flipbook" : "flyer"}/${userDto.company}/${flyerState.caption?.trim()}`}
                                                        </Typography>
                                                    </Box>
                                                    {/*<Box>*/}
                                                    {/*    <TextInputWithLabel*/}
                                                    {/*        labelGridSizeNumber={12}*/}
                                                    {/*        valueForInput={`${envManager.flyerAppAddress}/${userDto.company}/${flyerState.caption?.trim()}`}*/}
                                                    {/*        maxLength={1000}*/}
                                                    {/*        readonly={true}*/}
                                                    {/*        withoutPadding={true}*/}
                                                    {/*        fontSize={`16px`}*/}
                                                    {/*    />*/}
                                                    {/*</Box>*/}
                                                </Box>
                                                <Grid container alignItems={`center`}
                                                      sx={{height: `48px`, backgroundColor: `#F1F1F1`, px: `10px`}}
                                                      className={classes.languageWrapper}
                                                      mb={`20px`}>
                                                    <SelectWithLabel
                                                        labelGridSizeNumber={3}
                                                        valueForSelect={flyerState!.language!}
                                                        onChangeSelect={() => {
                                                        }}
                                                        selectArray={languages}
                                                        labelCaption={'language:'}
                                                        isBold={true}
                                                        isRequired={true}
                                                        readonly={true}
                                                        fontSize={`16`}
                                                        defaultFontForLabel={true}
                                                    />
                                                </Grid>
                                                <Box className={classes.durationWrapper} mb={`20px`}>
                                                    <Box mb={`5px`}>
                                                        <Typography fontWeight={700}>
                                                            Start & End Dates
                                                        </Typography>
                                                    </Box>
                                                    <Grid container columnSpacing={`10px`}>
                                                        <DatePickerComponent
                                                            datePickerGridSide={6}
                                                            datePickerValue={flyerState.startDate}
                                                            datePickerName={`startDate`}
                                                            onChangeValue={onChangeDatePicker}
                                                            datePickerRef={startDateRef}
                                                            datePickerLabelValue={`Start Date`}
                                                            maxDate={flyerState.endDate}
                                                        />
                                                        <DatePickerComponent
                                                            datePickerGridSide={6}
                                                            datePickerValue={flyerState.endDate}
                                                            datePickerName={`endDate`}
                                                            onChangeValue={onChangeDatePicker}
                                                            datePickerRef={endDateRef}
                                                            datePickerLabelValue={`End Date`}
                                                            minDate={flyerState.startDate}
                                                        />
                                                    </Grid>
                                                </Box>
                                                <Box className={classes.urlWrapper} mb={`20px`}>
                                                    <Box>
                                                        <Typography fontWeight={700}>
                                                            Flyer status
                                                        </Typography>
                                                    </Box>
                                                    <RadioGroup
                                                        row
                                                        value={flyerState.flyerStatusCode}
                                                        onChange={changeFlyerStatus}
                                                        className={classes.radioBtnGroup}
                                                        name={`flyerStatusCode`}
                                                    >
                                                        {FLYER_STATUSES.map((status: FlyerStatus) => {
                                                            return (
                                                                <FormControlLabel
                                                                    key={`${status.fstCode}${status.fstRecId}`}
                                                                    value={status.fstCode}
                                                                    control={<Radio size="small"/>}
                                                                    label={status.fstCaption}
                                                                    sx={{width: status.fstCode === 2 ? `20%` : `30%`}}
                                                                />
                                                            )
                                                        })}
                                                    </RadioGroup>

                                                </Box>
                                            </Box>
                                        }
                                        {
                                            tabPanelIndex === 1 &&
                                            <Box>
                                                <Box className={classes.captionWrapper} mb={`10px`}>
                                                    <Box mb={`5px`}>
                                                        <Typography fontWeight={700}>
                                                            Home Page
                                                        </Typography>
                                                    </Box>
                                                    <Grid container alignItems={`flex-start`}>
                                                        <TextInputWithLabel
                                                            isRequired={true}
                                                            isNotValid={!validator.isURL(flyerState?.homePage ? flyerState?.homePage : "")}
                                                            labelGridSizeNumber={12}
                                                            fontSize={`16px`}
                                                            valueForInput={flyerState.homePage}
                                                            onChangeInput={onChangeHomePageUrl}
                                                            isBold={true}
                                                            fieldName={`accountHomePageUrl`}
                                                            maxLength={1000}
                                                        />
                                                    </Grid>
                                                </Box>

                                                <Box>
                                                    <Box
                                                        display={`flex`}
                                                        alignItems={`center`}
                                                        m={`0 0 5px`}
                                                    >
                                                        <Typography fontWeight={700}>
                                                            Set GUI Color
                                                        </Typography>
                                                    </Box>
                                                    <Box>
                                                        <ColorsSelector
                                                            currentSelectedColor={flyerState.guiColor}
                                                            onColorSwatchChange={onGuiColorChange}
                                                            type={`color`}
                                                        />
                                                    </Box>
                                                </Box>
                                                <Box>
                                                    <Box
                                                        display={`flex`}
                                                        alignItems={`center`}
                                                        m={`10px 0 5px`}
                                                    >
                                                        <Typography fontWeight={700}>
                                                            Set Font
                                                        </Typography>
                                                    </Box>
                                                    <Box className={classes.dropdownSelector}>
                                                        <FontsSelect
                                                            fontName={{
                                                                value: flyerState.fontFamily ? flyerState.fontFamily : 'Roboto',
                                                                label: flyerState.fontFamily ? flyerState.fontFamily : 'Roboto'
                                                            }}
                                                            onChange={onFontSelectorChange}
                                                        />
                                                    </Box>
                                                </Box>
{/*
                                                <Box>
                                                    <Box
                                                        display={`flex`}
                                                        alignItems={`center`}
                                                        m={`10px 0 5px`}
                                                    >
                                                        <Typography fontWeight={700}>
                                                            Set Icon Style
                                                        </Typography>
                                                    </Box>
                                                    <Box className={classes.dropdownSelector}>
                                                        <IconsStylesDropdown
                                                            iconStyle={flyerState.iconStyle!}
                                                            setIconStyle={setIconStyle}
                                                            mainColor={flyerState.guiColor || ""}
                                                        />
                                                    </Box>
                                                </Box>
*/}
                                                <Box
                                                    className={classes.uploadLogoWrapper}
                                                >
                                                    {
                                                        flyerState.logo &&
                                                        <Box
                                                            className={classes.uploadedLogoView}
                                                            sx={{
                                                                backgroundColor: flyerState.guiColor
                                                            }}
                                                        >
                                                            <AsyncImageWithLoader src={flyerState.logo ? flyerState.logo : ``}/>
                                                        </Box>
                                                    }

                                                    <Button
                                                        variant="contained"
                                                        component="label"
                                                        className={classes.uploadLogoButton}
                                                    >
                                                        <UploadCloudIcon/>
                                                        <Typography color={`#000000`} mx={`10px`}>
                                                            {`Upload Logo`}
                                                        </Typography>
                                                        <input
                                                            type="file"
                                                            accept={`.jpg, .png, .jpeg`}
                                                            multiple={false}
                                                            onChange={onUploadLogoFileChange}
                                                            hidden
                                                        />
                                                    </Button>
                                                </Box>
                                                <Box pb={`5px`}>
                                                    <Box
                                                        display={`flex`}
                                                        alignItems={`center`}
                                                        m={`10px 0 5px`}
                                                    >
                                                        <Typography fontWeight={700}>
                                                            Set Background Color
                                                        </Typography>
                                                    </Box>
                                                    <Box>
                                                        <ColorsSelector
                                                            currentSelectedColor={flyerState.bgColor}
                                                            onColorSwatchChange={onBgColorChange}
                                                            type={`backgroundColor`}
                                                            backgroundImageURL={flyerState.bgImage}
                                                            isImageUrlSelected={isImageUrlSelected}
                                                            abovePosition={true}
                                                        />
                                                    </Box>
                                                </Box>
                                                <Box
                                                    className={classes.uploadLogoWrapper}
                                                >
                                                    {
                                                        flyerState.bgImage && isImageUrlSelected &&
                                                        <Box
                                                            className={classes.uploadedLogoView}
                                                        >
                                                            <AsyncImageWithLoader
                                                                src={flyerState.bgImage && isImageUrlSelected ? flyerState.bgImage : ``}/>
                                                        </Box>
                                                    }

                                                    <Button
                                                        variant="contained"
                                                        component="label"
                                                        className={classes.uploadLogoButton}
                                                    >
                                                        <UploadCloudIcon/>
                                                        <Typography color={`#000000`} mx={`10px`}>
                                                            {`Upload Background`}
                                                        </Typography>
                                                        <input
                                                            type="file"
                                                            accept={`.jpg, .png, .jpeg`}
                                                            multiple={false}
                                                            onChange={onUploadBgFileChange}
                                                            hidden
                                                        />
                                                    </Button>
                                                </Box>
                                            </Box>
                                        }
                                        {
                                            tabPanelIndex === 2 &&
                                            <FlippingFlyerTocTab/>
                                        }
                                    </Box>
                                </Box>
                            }
                        </Box>
                        {
                            flyerDetailsState.flyRecId !== 0 &&
                            <Box
                                display={`flex`}
                            >
                                <Button
                                    onClick={onSaveFlyer}
                                    className={classes.controlButton}
                                    disabled={checkAllRequirementsForSavingFlyer()}
                                >
                                    <Typography
                                        color={`#ffffff`} fontWeight={500}
                                    >
                                        Save
                                    </Typography>
                                </Button>
                                <Button
                                    onClick={openFlyerInTab}
                                    className={classes.controlButton}
                                    disabled={!compareDefaultItemStateWithCurrentItemState()}
                                >
                                    <Typography
                                        color={`#ffffff`} fontWeight={500}
                                    >
                                        Open
                                    </Typography>
                                </Button>
                            </Box>
                        }
                    </Box>
                </>
            }
            {isModalPopup && <StatusPopup
                settings={settingsForPopup}
                type={StatusPopupType.INFO}
                title={'INFO'}
                subTitle={''}
                messages={[settingsForPopup.messages]}
                show={isModalPopup}
                handleClose={onCloseConfirmPopup}
            />
            }
        </Box>
    )
}